// src/providers/SupabaseProvider.tsx
import React, { createContext, useContext } from "react";
import { useSupabase } from "../hooks/useSupabase";

const SupabaseContext = createContext<ReturnType<typeof useSupabase> | null>(
  null
);

export const SupabaseProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const supabase = useSupabase();

  return (
    <SupabaseContext.Provider value={supabase}>
      {children}
    </SupabaseContext.Provider>
  );
};

export const useSupabaseContext = () => {
  const context = useContext(SupabaseContext);
  if (!context) {
    throw new Error(
      "useSupabaseContext deve ser usado dentro de SupabaseProvider"
    );
  }
  return context;
};
